
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SidebarToggleProps {
  collapsed: boolean;
  onToggle: () => void;
}

export const SidebarToggle: React.FC<SidebarToggleProps> = ({
  collapsed,
  onToggle
}) => {
  return (
    <div className="p-4 flex-shrink-0 px-[8px] py-[8px] my-[32px]">
      <div className={cn("flex transition-all duration-200", collapsed ? "justify-center" : "justify-start")}>
        <button 
          onClick={onToggle} 
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"} 
          className="flex items-center justify-center w-8 h-8 text-gray-500 rounded-full font-thin px-0 transition-all duration-200 ease-in-out hover:scale-105 shadow-md hover:shadow-lg bg-white mx-0"
        >
          {collapsed ? (
            <ChevronRight size={20} className="transition-transform duration-200" />
          ) : (
            <ChevronLeft size={20} className="transition-transform duration-200" />
          )}
        </button>
      </div>
    </div>
  );
};
